'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { FC, ReactNode, useState } from 'react'

interface TanstackQueryProviderProps {
    children: ReactNode;
}

export const TanstackQueryProvider: FC<TanstackQueryProviderProps> = ({ children }) => {
  const [queryClient] = useState(() => new QueryClient({
      defaultOptions: {
          queries: {
              refetchOnWindowFocus: false,
              retry: false,
              staleTime: 10_000,
          },
      }
  }))

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}